function initProductForm(elements) {
  let forms = document.querySelectorAll(elements);

  if (!forms) return;

  forms.forEach((form) => {
    new theme.AjaxProduct(form);
  });
}

function productStickyBar() {
  let observe = document.querySelector(".payment-buttons");

  if (!observe) return;

  var observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
                    document
            .querySelector("[product-sticky-bar]")
            ?.classList.remove("is-visible");
        } else {
                    document
            .querySelector("[product-sticky-bar]")
            ?.classList.add("is-visible");
        }
      });
    },
    { rootMargin: "0px 0px 100px 0px" }
  );

  observer.observe(observe);
}

document.addEventListener("DOMContentLoaded", function () {
  initProductForm(".product-grid-item-product-form");
  initProductForm('.product-sticky-bar form');

  document.addEventListener("recommendations:loaded", function () {
    initProductForm(".product-grid-item-product-form");
  });

  productStickyBar();
});
